/**
 * Class name utility for merging Tailwind CSS classes
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using clsx and tailwind-merge
 *
 * This utility function provides a consistent way to merge Tailwind CSS classes
 * with proper conflict resolution. It's especially useful for:
 * - Conditional classes
 * - Component variants
 * - Merging default and custom classes
 *
 * @example
 * ```tsx
 * cn('px-4 py-2', isActive && 'bg-blue-500', className)
 * ```
 *
 * @param inputs - Class values to merge (strings, objects, arrays)
 * @returns Merged class string with conflicts resolved
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
